import { CustomerPortalUser } from "../../Models/CustomerPortalUser";
import { PortalPreQualifyInfo } from "../../Models/PortalPreQualifyInfo";
import { PortalValidationResult } from "../../Models/PortalValidationResult";
import { PreQualifyResult } from "../../Models/PreQualifyResult";
import { CreateUpdateReference, Reference } from "../../Models/Reference";
import { StipDocument } from "../../Models/StipDocument";
import { Stipulation } from "../../Models/Stipulation";
import { StipulationCategory } from "../../Models/StipulationCategory";

export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_APPLICATION_LINK_SUCCESS';
export const SET_USER = 'SET_USER';
export const FAILED_LOGIN = 'FAILED_LOGIN';
export const GET_STIPULATION_CATEGORIES = 'GET_STIPULATION_CATEGORIES';
export const GET_STIPULATION_CATEGORIES_SUCCESS = 'GET_STIPULATION_CATEGORIES_SUCCESS';
export const GET_STIPULATIONS = 'GET_STIPULATIONS';
export const GET_STIPULATIONS_SUCCESS = 'GET_STIPULATIONS_SUCCESS';
export const GET_STIPULATION_DOCUMENTS = 'GET_STIPULATION_DOCUMENTS';
export const GET_STIPULATION_DOCUMENTS_SUCCESS = 'GET_STIPULATION_DOCUMENTS_SUCCESS';
export const UPDATE_STIP_DOCUMENT = 'UPDATE_STIP_DOCUMENT';
export const UPDATE_STIP_DOCUMENT_SUCCESS = 'UPDATE_STIP_DOCUMENT_SUCCESS';
export const UPLOAD_STIP_DOCUMENTS = 'UPLOAD_STIP_DOCUMENTS';
export const LOAD_REFERENCES = 'LOAD_REFERENCES';
export const LOAD_REFERENCES_SUCCESS = 'LOAD_REFERENCES_SUCCESS';
export const CREATE_REFERENCE = 'CREATE_REFERENCE';
export const CREATE_REFERENCE_SUCCESS = 'CREATE_REFERENCE_SUCCESS';
export const UPDATE_REFERENCE = 'UPDATE_REFERENCE';
export const UPDATE_REFERENCE_SUCCESS = 'UPDATE_REFERENCE_SUCCESS';
export const DELETE_REFERENCE = 'DELETE_REFERENCE';
export const DELETE_REFERENCE_SUCCESS = 'DELETE_REFERENCE_SUCCESS';
export const SCHEDULE_APPOINTMENT = 'SCHEDULE_APPOINTMENT';
export const SCHEDULE_APPOINTMENT_SUCCESS = 'SCHEDULE_APPOINTMENT_SUCCESS';
export const PORTAL_VALIDATION_ERROR = 'PORTAL_VALIDATION_ERROR';
export const REMOVE_SCHEDULING_APPT_LOADER = 'REMOVE_SCHEDULING_APPT_LOADER';
export const ADD_STIP_DOCUMENT_TO_DICTIONARY = 'ADD_STIP_DOCUMENT_TO_DICTIONARY';
export const ADD_STIP_DOCUMENTS_TO_DICTIONARY = 'ADD_STIP_DOCUMENTS_TO_DICTIONARY';
export const UPDATE_PREFERS_SPANISH = 'UPDATE_PREFERS_SPANISH';
export const UPDATE_PREFERS_SPANISH_SUCCESS = 'UPDATE_PREFERS_SPANISH_SUCCESS';
export const GET_PORTAL_PRE_QUALIFICATION_RESULT = 'GET_PORTAL_PRE_QUALIFICATION_RESULT';
export const GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS = 'GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS';
export const SET_IS_GETTING_PORTAL_PRE_QUALIFICATION_RESULT = 'SET_IS_GETTING_PORTAL_PRE_QUALIFICATION_RESULT';

export interface GetUserAction {
  type: typeof GET_USER;
  payload: { customerPortalLinkId: string }
}

export const getUser = (customerPortalLinkId: string): GetUserAction => {
  return {
    type: GET_USER,
    payload: { customerPortalLinkId: customerPortalLinkId }
  };
}

export interface GetUserSuccessAction {
  type: typeof GET_USER_SUCCESS;
  payload: { user: CustomerPortalUser, portalValidationResult: PortalValidationResult }
}

export const getUserSuccess = (user: CustomerPortalUser, portalValidationResult: PortalValidationResult): GetUserSuccessAction => {
  return {
    type: GET_USER_SUCCESS,
    payload: { user, portalValidationResult }
  };
}

// Set user
export interface SetUserAction {
  type: typeof SET_USER;
  payload: { user: CustomerPortalUser }
}

export const setUser = (user: CustomerPortalUser): SetUserAction => {
  return {
    type: SET_USER,
    payload: { user }
  };
}

// Failed login
export interface FailedLoginAction {
  type: typeof FAILED_LOGIN;
}

export const failedLogin = (): FailedLoginAction => {
  return {
    type: FAILED_LOGIN
  };
}

// Get stipulation categories
export interface GetStipulationCategoriesAction {
  type: typeof GET_STIPULATION_CATEGORIES;
  payload: { customerPortalLinkId: string }
}

export const getStipulationCategories = (customerPortalLinkId: string): GetStipulationCategoriesAction => {
  return {
    type: GET_STIPULATION_CATEGORIES,
    payload: { customerPortalLinkId }
  };
}

export interface GetStipulationCategoriesSuccessAction {
  type: typeof GET_STIPULATION_CATEGORIES_SUCCESS;
  payload: { stipulationCategories: StipulationCategory[] }
}

export const getStipulationCategoriesSuccess = (stipulationCategories: StipulationCategory[]): GetStipulationCategoriesSuccessAction => {
  return {
    type: GET_STIPULATION_CATEGORIES_SUCCESS,
    payload: { stipulationCategories }
  };
}

// Get stipulations
export interface GetStipulationsAction {
  type: typeof GET_STIPULATIONS;
  payload: { customerPortalLinkId: string }
}

export const getStipulations = (customerPortalLinkId: string): GetStipulationsAction => {
  return {
    type: GET_STIPULATIONS,
    payload: { customerPortalLinkId }
  };
}

export interface GetStipulationsSuccessAction {
  type: typeof GET_STIPULATIONS_SUCCESS;
  payload: { stipulations: Stipulation[] }
}

export const getStipulationsSuccess = (stipulations: Stipulation[]): GetStipulationsSuccessAction => {
  return {
    type: GET_STIPULATIONS_SUCCESS,
    payload: { stipulations }
  };
}

// Get stipulation documents
export interface GetStipulationDocumentsAction {
  type: typeof GET_STIPULATION_DOCUMENTS;
  payload: { applicationId: string, customerPortalLinkId: string, customerId: string }
}

export const getStipulationDocuments = (applicationId: string, customerPortalLinkId: string, appCustomerId: string): GetStipulationDocumentsAction => {
  return {
    type: GET_STIPULATION_DOCUMENTS,
    payload: { applicationId, customerPortalLinkId, customerId: appCustomerId }
  };
}

export interface GetStipulationDocumentsSuccessAction {
  type: typeof GET_STIPULATION_DOCUMENTS_SUCCESS;
  payload: { stipulationDocuments: StipDocument[] }
}

export const getStipulationDocumentsSuccess = (stipulationDocuments: StipDocument[]): GetStipulationDocumentsSuccessAction => {
  return {
    type: GET_STIPULATION_DOCUMENTS_SUCCESS,
    payload: { stipulationDocuments }
  };
}

// Upload stipulation documents
export interface UploadStipulationDocumentsAction {
  type: typeof UPLOAD_STIP_DOCUMENTS;
  payload: { stipulationDocuments: StipDocument[] }
}

export const uploadStipulationDocuments = (stipulationDocuments: StipDocument[]): UploadStipulationDocumentsAction => {
  return {
    type: UPLOAD_STIP_DOCUMENTS,
    payload: { stipulationDocuments }
  };
}

// Rename stipulation document
export interface UpdateStipDocumentAction {
  type: typeof UPDATE_STIP_DOCUMENT;
  payload: { stipDocumentId: string, appCustomerId: string, customerPortalLinkId: string, newFileName: string, stipulationId: number }
}

export const updateStipDocument = (stipDocumentId: string, customerId: string, customerPortalLinkId: string, newFileName: string, stipulationId: number): UpdateStipDocumentAction => {
  return {
    type: UPDATE_STIP_DOCUMENT,
    payload: { stipDocumentId, appCustomerId: customerId, customerPortalLinkId, newFileName, stipulationId }
  };
}

export interface UpdateStipDocumentSuccessAction {
  type: typeof UPDATE_STIP_DOCUMENT_SUCCESS;
  payload: { stipDocumentId: string, newDocumentName: string, stipulationId: number }
}

export const updateStipDocumentSuccess = (stipDocumentId: string, newFileName: string, stipulationId: number): UpdateStipDocumentSuccessAction => {
  return {
    type: UPDATE_STIP_DOCUMENT_SUCCESS,
    payload: { stipDocumentId, newDocumentName: newFileName, stipulationId }
  };
}

// Reference actions
export interface LoadReferencesAction {
  type: typeof LOAD_REFERENCES;
  payload: { customerId: string, customerPortalLinkId: string }
}

export const loadReferences = (customerId: string, customerPortalLinkId: string): LoadReferencesAction => {
  return {
    type: LOAD_REFERENCES,
    payload: { customerId, customerPortalLinkId }
  };
}

export interface LoadReferencesSuccessAction {
  type: typeof LOAD_REFERENCES_SUCCESS;
  payload: { references: Reference[] }
}

export const loadReferencesSuccess = (references: Reference[]): LoadReferencesSuccessAction => {
  return {
    type: LOAD_REFERENCES_SUCCESS,
    payload: { references }
  };
}

export interface CreateReferenceAction {
  type: typeof CREATE_REFERENCE;
  payload: { customerId: string, customerPortalLinkId: string, reference: CreateUpdateReference }
}

export const createReference = (customerId: string, customerPortalLinkId: string, reference: CreateUpdateReference): CreateReferenceAction => {
  return {
    type: CREATE_REFERENCE,
    payload: { customerId, customerPortalLinkId, reference }
  };
}

export interface CreateReferenceSuccessAction {
  type: typeof CREATE_REFERENCE_SUCCESS;
  payload: { reference: Reference }
}

export const createReferenceSuccess = (reference: Reference): CreateReferenceSuccessAction => {
  return {
    type: CREATE_REFERENCE_SUCCESS,
    payload: { reference }
  };
}


export interface UpdateReferenceAction {
  type: typeof UPDATE_REFERENCE;
  payload: { customerPortalLinkId: string, reference: CreateUpdateReference }
}

export const updateReference = (customerPortalLinkId: string, reference: CreateUpdateReference): UpdateReferenceAction => {
  return {
    type: UPDATE_REFERENCE,
    payload: { customerPortalLinkId, reference }
  };
}

export interface UpdateReferenceSuccessAction {
  type: typeof UPDATE_REFERENCE_SUCCESS;
  payload: { reference: Reference }
}

export const updateReferenceSuccess = (reference: Reference): UpdateReferenceSuccessAction => {
  return {
    type: UPDATE_REFERENCE_SUCCESS,
    payload: { reference }
  };
}

export interface DeleteReferenceAction {
  type: typeof DELETE_REFERENCE;
  payload: { customerId: string, customerPortalLinkId: string, referenceId: string }
}

export const deleteReference = (customerId: string, customerPortalLinkId: string, referenceId: string): DeleteReferenceAction => {
  return {
    type: DELETE_REFERENCE,
    payload: { customerId, customerPortalLinkId, referenceId }
  };
}

export interface DeleteReferenceSuccessAction {
  type: typeof DELETE_REFERENCE_SUCCESS;
  payload: { referenceId: string }
}

export const deleteReferenceSuccess = (referenceId: string): DeleteReferenceSuccessAction => {
  return {
    type: DELETE_REFERENCE_SUCCESS,
    payload: { referenceId }
  };
}

// Schedule appointment
export interface ScheduleAppointmentAction {
  type: typeof SCHEDULE_APPOINTMENT;
  payload: { customerPortalLinkId: string, appointmentDate: Date }
}

export const scheduleAppointment = (customerPortalLinkId: string, appointmentDate: Date): ScheduleAppointmentAction => {
  return {
    type: SCHEDULE_APPOINTMENT,
    payload: { customerPortalLinkId, appointmentDate }
  };
}

export interface ScheduleAppointmentSuccessAction {
  type: typeof SCHEDULE_APPOINTMENT_SUCCESS;
  payload: { appointmentDate: Date }
}

export const scheduleAppointmentSuccess = (appointmentDate: Date): ScheduleAppointmentSuccessAction => {
  return {
    type: SCHEDULE_APPOINTMENT_SUCCESS,
    payload: { appointmentDate }
  };
}

export interface PortalValidationErrorAction {
  type: typeof PORTAL_VALIDATION_ERROR;
  payload: { portalValidationResult: PortalValidationResult }
}

export const portalValidationError = (portalValidationResult: PortalValidationResult): PortalValidationErrorAction => {
  return {
    type: PORTAL_VALIDATION_ERROR,
    payload: { portalValidationResult }
  };
}

export interface RemoveSchedulingApptLoaderAction {
  type: typeof REMOVE_SCHEDULING_APPT_LOADER;
}

export const removeSchedulingApptLoader = (): RemoveSchedulingApptLoaderAction => {
  return {
    type: REMOVE_SCHEDULING_APPT_LOADER
  };
}

export interface AddStipDocumentToDictionaryAction {
  type: typeof ADD_STIP_DOCUMENT_TO_DICTIONARY;
  payload: { stipDocumentId: string, objectUrl: string }
}

export const addStipDocumentToDictionary = (stipDocumentId: string, objectUrl: string): AddStipDocumentToDictionaryAction => {
  return {
    type: ADD_STIP_DOCUMENT_TO_DICTIONARY,
    payload: { stipDocumentId, objectUrl }
  };
}

export interface AddStipDocumentsToDictionaryAction {
  type: typeof ADD_STIP_DOCUMENTS_TO_DICTIONARY;
  payload: { items: { stipDocumentId: string, objectUrl: string }[] }
}

export const addStipDocumentsToDictionary = (items: { stipDocumentId: string, objectUrl: string }[]): AddStipDocumentsToDictionaryAction => {
  return {
    type: ADD_STIP_DOCUMENTS_TO_DICTIONARY,
    payload: { items }
  };
}

export interface UpdatePrefersSpanishAction {
  type: typeof UPDATE_PREFERS_SPANISH;
  payload: { contactId: string, customerPortalLinkId: string, prefersSpanish: boolean }
}

export const updatePrefersSpanish = (contactId: string, customerPortalLinkId: string, prefersSpanish: boolean): UpdatePrefersSpanishAction => {
  return {
    type: UPDATE_PREFERS_SPANISH,
    payload: { contactId, customerPortalLinkId, prefersSpanish }
  };
}

export interface UpdatePrefersSpanishSuccessAction {
  type: typeof UPDATE_PREFERS_SPANISH_SUCCESS;
  payload: { prefersSpanish: boolean }
}

export const updatePrefersSpanishSuccess = (prefersSpanish: boolean): UpdatePrefersSpanishSuccessAction => {
  return {
    type: UPDATE_PREFERS_SPANISH_SUCCESS,
    payload: { prefersSpanish }
  };
}

export interface GetPortalPreQualificationResultAction {
  type: typeof GET_PORTAL_PRE_QUALIFICATION_RESULT;
  payload: { customerPortalLinkId: string }
}

export const getPortalPreQualificationResult = (customerPortalLinkId: string): GetPortalPreQualificationResultAction => {
  return {
    type: GET_PORTAL_PRE_QUALIFICATION_RESULT,
    payload: { customerPortalLinkId }
  };
}

export interface GetPortalPreQualificationResultSuccessAction {
  type: typeof GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS;
  payload: { preQualificationResult: PortalPreQualifyInfo }
}

export const getPortalPreQualificationResultSuccess = (preQualificationResult: PortalPreQualifyInfo): GetPortalPreQualificationResultSuccessAction => {
  return {
    type: GET_PORTAL_PRE_QUALIFICATION_RESULT_SUCCESS,
    payload: { preQualificationResult }
  };
}

export interface SetIsGettingPortalPreQualificationResultAction {
  type: typeof SET_IS_GETTING_PORTAL_PRE_QUALIFICATION_RESULT;
  payload: { isGettingPreQualificationResult: boolean }
}

export const setIsGettingPortalPreQualificationResult = (isGettingPreQualificationResult: boolean): SetIsGettingPortalPreQualificationResultAction => {
  return {
    type: SET_IS_GETTING_PORTAL_PRE_QUALIFICATION_RESULT,
    payload: { isGettingPreQualificationResult }
  };
}

export type CustomerPortalAction =
  | GetUserAction
  | GetUserSuccessAction
  | SetUserAction
  | FailedLoginAction
  | GetStipulationCategoriesAction
  | GetStipulationCategoriesSuccessAction
  | GetStipulationsAction
  | GetStipulationsSuccessAction
  | GetStipulationDocumentsAction
  | GetStipulationDocumentsSuccessAction
  | UpdateStipDocumentAction
  | UpdateStipDocumentSuccessAction
  | UploadStipulationDocumentsAction
  | LoadReferencesAction
  | LoadReferencesSuccessAction
  | CreateReferenceAction
  | CreateReferenceSuccessAction
  | UpdateReferenceAction
  | UpdateReferenceSuccessAction
  | DeleteReferenceAction
  | DeleteReferenceSuccessAction
  | ScheduleAppointmentAction
  | ScheduleAppointmentSuccessAction
  | PortalValidationErrorAction
  | RemoveSchedulingApptLoaderAction
  | AddStipDocumentToDictionaryAction
  | AddStipDocumentsToDictionaryAction
  | UpdatePrefersSpanishAction
  | UpdatePrefersSpanishSuccessAction
  | GetPortalPreQualificationResultAction
  | GetPortalPreQualificationResultSuccessAction
  | SetIsGettingPortalPreQualificationResultAction;